'use client';
import styles from './RegularOpeningHours.module.scss';

export default function RegularOpeningHours({ hours, isOpen }) {
  if (!hours || !isOpen) return null;

  const allHoursNull = Object.keys(hours).every((key) => key === 'id' || hours[key] === null);
  if (allHoursNull) return null;

  const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  return (
    <div className={styles.wrapper}>
      <h3>Regular opening hours:</h3>
      {days.map((day, index) => {
        const displayDay = day.charAt(0).toUpperCase() + day.slice(1);
        const isDayOpen = isOpen[day] === 'open';
        const displayHours = isDayOpen ? hours[day] : 'closed';
        return (
          <div key={index} className={styles.hours}>
            <span>{displayDay}</span>
            <span>{displayHours}</span>
          </div>
        );
      })}
    </div>
  );
}
